import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import * as React from 'react';

var GlobalZIndex = /*#__PURE__*/function () {
  function GlobalZIndex() {
    _classCallCheck(this, GlobalZIndex);

    this.zIndex = void 0;
    this.zIndex = 1000;
  }

  _createClass(GlobalZIndex, [{
    key: "value",
    get: function get() {
      // eslint-disable-next-line no-plusplus
      return this.zIndex++;
    }
  }]);

  return GlobalZIndex;
}();

export var globalZIndex = new GlobalZIndex();
var GlobalZIndexContext = /*#__PURE__*/React.createContext(globalZIndex);
GlobalZIndexContext.displayName = 'GlobalZIndexContext';
export var GlobalZIndexProvider = GlobalZIndexContext.Provider;
export var GloablZIndexConsumer = GlobalZIndexContext.Consumer;
export default GlobalZIndexContext;